import { Component, Input, ViewChild } from '@angular/core';
import { NavController } from 'ionic-angular';


import { Account } from '../../../model/account';
import { Subscription } from 'rxjs';
import { UserManager } from '../../../services/managers/user.manager';

import { Organization } from '../../../model/organization';
import { NavParams } from 'ionic-angular';
import { AccountHelper } from '../../../lib/accountHelper';
import { ClassificationSection } from './classification/classifications';

@Component({
    selector: 'manage-admin',
    templateUrl: 'admin.html'
})
export class AdminPage {
    @Input('organization') organization: Organization;
    @ViewChild('classifications') classifications: ClassificationSection;

    viewMode = 'texting';
    viewSubMode = 'manage';
    
    accountHelper = AccountHelper.instance();
    account: Account = new Account();

    loadingData: boolean = true;
    popoverActive: boolean;

    condensed: boolean;
    prompted: boolean;
    subscriptions: Subscription[] = [];    

    constructor(public nav: NavController, navParams: NavParams, private userManager : UserManager) { }

    ionViewDidEnter() {
        this.subscriptions.push(this.userManager.account.subscribe(account => {
            this.account = account as Account;
        }));
    }

    ionViewWillLeave() {
        for(let i = 0; i < this.subscriptions.length; i++) {
            let subscription = this.subscriptions[i];

            if (!subscription.closed)
                subscription.unsubscribe();
        }
    }
    
    showClassifications() {
        this.viewMode = 'classifications';
        this.viewSubMode = 'overview';
        this.classifications.load();
        console.log("called classifications.load");
    }

    back() {
        this.nav.pop();
    }
}


// WEBPACK FOOTER //
// ./src/pages/staff/admin/admin.ts